function showPassword( )
{
    var passwordInput = document.getElementById( "CreatePassword" );
    
    if( passwordInput.type == "password" )
    {
        passwordInput.type = "text"
    }
    else
    {
        passwordInput.type = "password"
    }
}